import React from 'react';
export default function SeatsTab() {
  return (
    <div className="alert alert-info mt-4">Seat matrix and quota breakdown coming soon.</div>
  );
}